export const DEFAULT_PAYMENT_SETTINGS = {
  max_payments: 3,
  payment_interval: 1,
  photo_url_default_lic_cot: "",
};

export const DEFAULT_PAYMENT_IMAGE = "/img/no-image.jpg";

export function unwrapSettings(data) {
  if (Array.isArray(data)) return data[0] || null;
  return data || null;
}

export function toNumber(value, defaultValue = 1) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : defaultValue;
}

export function normalizePaymentPayload(settings) {
  return {
    ...settings,
    max_payments: toNumber(settings?.max_payments, 1),
    payment_interval: toNumber(settings?.payment_interval, 1),
    photo_url_default_lic_cot: String(
      settings?.photo_url_default_lic_cot || ""
    ).trim(),
  };
}

export function validatePaymentSettings(settings) {
  const maxPayments = Number(settings?.max_payments);
  const interval = Number(settings?.payment_interval);

  if (!Number.isFinite(maxPayments) || maxPayments < 1) {
    return "Le nombre maximum de paiements doit être supérieur ou égal à 1.";
  }

  if (!Number.isFinite(interval) || interval < 1) {
    return "L’espacement des paiements doit être supérieur ou égal à 1 mois.";
  }

  return "";
}

export function validateImageFile(file) {
  if (!file) return "Veuillez sélectionner une image.";

  const validType = /^image\/(png|jpe?g|webp)$/i.test(file.type);

  if (!validType) {
    return "Format non supporté. Utilisez PNG, JPG ou WEBP.";
  }

  if (file.size > 10 * 1024 * 1024) {
    return "Fichier trop volumineux. Taille maximale : 10 Mo.";
  }

  return "";
}

export function withBust(url, version) {
  if (!url) return url;
  return `${url}${url.includes("?") ? "&" : "?"}v=${version}`;
}